import styles from './PlainEnglish.module.css'

const PHRASES = [
  'put this window on the left half',
  'open my music app',
  'turn the volume down',
]

/**
 * Example phrases for plain-English action assignment, set as oversized
 * command lines. These are illustrative inputs, not a screenshot of the
 * app and not a chat interface.
 */
export function PlainEnglish() {
  return (
    <div className={styles.wrap}>
      <ul className={styles.list}>
        {PHRASES.map((phrase, i) => (
          <li
            key={phrase}
            className={styles.item}
            style={{ '--i': i } as React.CSSProperties}
          >
            <span className={styles.marker} aria-hidden="true" />
            <span className={styles.phrase}>
              <span className={styles.quote} aria-hidden="true">
                &ldquo;
              </span>
              {phrase}
              <span className={styles.quote} aria-hidden="true">
                &rdquo;
              </span>
            </span>
          </li>
        ))}
      </ul>

      <p className={styles.note}>
        Each one resolved <span className={styles.noteAccent}>on your Mac</span>.
      </p>
    </div>
  )
}
